import format from "date-fns/format";
import React, { useState } from "react";
import { Exercise } from "../../../models/Exercise";
import useMethodAccount from "../hooks/useMethodAccount";
import "./style.scss";
import { useTranslation } from "react-i18next";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import EAButton from "../../shared/Buttons/EAButton";
import EAAlert from "../../shared/EAAlert";

interface IProps {
  exercise: Exercise;
  getSelect: () => void;
}

const SingleExerciseMobile: React.FC<IProps> = ({ exercise, getSelect }: IProps) => {
  const [open, setOpen] = useState(true);
  const { t } = useTranslation();
  const { resignExercise } = useMethodAccount();
  const currentTime = new Date();
  const currentTimev2 = currentTime.getTime();
  const locale = useLocaleByLanguage();
  const [cancelReservation, setCancelReservation] = useState<boolean>(true);

  return (
    <>
      {exercise.startTime > currentTimev2 && (
        <div className="purchased-assort__mobile purchased-assort">
          <div className="purchased-assort_body__mobile">
            {exercise.status === "A" && <EAAlert type="success" compact message={"Zapisany"} />}
            {exercise.status === "R" && (
              <EAAlert
                type="warning"
                compact
                message={`Lista rezerwowa, jesteś ${exercise.waitListPosition} w kolejce`}
              />
            )}

            <b className="purchased-assort_body__details__mobile">
              <b>{format(exercise.startTime, " d MMMM (cccc), HH:mm", { locale: locale })}</b>
            </b>

            <h5> {exercise.name}</h5>
          </div>

          <div className="purchased-assort_action">
            {cancelReservation ? (
              <EAButton
                title={t("zrezygnuj")}
                onClick={() => setCancelReservation(false)}
                color="error"
                variant="filled"
              />
            ) : (
              <div className="resing-wrapper resing-wrapper__mobile">
                <h5>Czy na pewno chcesz zrezygnować ?</h5>
                <div>
                  <EAButton
                    title={t("tak_rezygnuje")}
                    onClick={() => {
                      resignExercise(exercise.objectId);
                      getSelect();
                      setOpen(!open);
                    }}
                    color="error"
                    variant="filled"
                  />

                  <EAButton
                    title={t("nie")}
                    onClick={() => setCancelReservation(true)}
                    color="error"
                    variant="outlined"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SingleExerciseMobile;
